import { CommonModule } from '@angular/common';
import { Component, Inject, TemplateRef } from '@angular/core';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { CasualTournamentEntity } from '@fantaz/shared/data-access/models';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'fz-bottom-sheet-card',
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss'],
})
export class BottomSheetCardComponent {
  constructor(
    // inject dependencies
    private readonly _bottomSheetRef: MatBottomSheetRef<BottomSheetCardComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA)
    public data: {
      source: MouseEvent;
      template: TemplateRef<any>;
      tournament: CasualTournamentEntity;
    },
  ) {}
}
